import { useEffect } from 'react';
import Slider from '../UI/Slider/Slider';
import { SwiperSlide } from 'swiper/react';

// data
import { data } from '../../data/Servece';

// style
import style from './service.module.css';

const Services = () => {
  return (
    <section className={style.section}>
      <div className="container">
        <div className={style.title}>
          <h2>
            У нас можно <span>круто</span> провести
          </h2>
        </div>
        <div className={style.content}>
          <div className={style.slider}>
            {data == false ? (
              <div className={style.error}>
                <div className="loader"></div>
              </div>
            ) : (
              <Slider loop={true} navigation={false} autoplay={true}>
                {data.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className={style.card}>
                      <div className={style.card_img}>
                        <img src={`./imgs/services/${item.img}`} alt="" />
                      </div>
                      <div className={style.card_title}>
                        <h3>
                          {item.title} <span>{item.icon}</span>
                        </h3>
                        <span>{item.desc}</span>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Services;
